import React, { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Flex from './../../../common/Flex';
import ForgetPwdForm  from './forgetPwdForm';
import withAuthSplit from './../../../../hoc/withAuthSplit';
import bgImg from './../../../../assets/img/generic/21.jpg';

const ForgetPwd = (props) => {
    const { setBgProps }=props;
  useEffect(() => setBgProps({ image: bgImg, position: '50% 20%' }), [setBgProps]);

  return (
    <Fragment>
      <Flex align="center" justify="center">
        <h3>Enter Registered Email ID</h3>
      </Flex>
      <ForgetPwdForm layout="split" hasLabel {...props} />
    </Fragment>
  );
};

ForgetPwd.propTypes = { setBgProps: PropTypes.func.isRequired };

export default withAuthSplit(ForgetPwd);
